// extracted by mini-css-extract-plugin
export var head = "Header-module--head--+TjJE";
export var links = "Header-module--links--ot4nq";
export var logo = "Header-module--logo--m3PE5";
export var logobox = "Header-module--logobox--mzs-B";
export var title = "Header-module--title--z8RW8";